export const permissionsKeys = {
  page: 'micro-sites.dynamic-sites.page-templates',
  pageBlockFind: 'page-dynamic-template.view',
  pageBlockCreate: 'page-dynamic-template.create',
  pageBlockUpdate: 'page-dynamic-template.update',
  pageBlockRemove: 'page-dynamic-template.delete',
  pageBlockShare: 'page-dynamic-template.share',
  pageBlockApply: 'page-dynamic-template.apply',
} as const;

export type TemplatePermissionsKeys = typeof permissionsKeys;
